import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-most-view-book',
  templateUrl: './edit-most-view-book.component.html',
  styleUrls: ['./edit-most-view-book.component.scss']
})
export class EditMostViewBookComponent implements OnInit {
formData: any = {
  bookName: '',
  bookDescription: '',
  autherName: '',
  categoryId: null,
  subCategoryId: null,
  fileTypeId: '',
  imgFile: null,
  bookFile: null,
};
// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
      public currentPage = 1; 
  public categories : any
  public totalItems = 0;
subCategories: any[] = [];

  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute,    private loading : LoadingService
        ,private translate: TranslateService
    ) { }
  
    ngOnInit(): void {
          this.getMainCategories();

      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
fetchBookForEdit(id: number): void {
  this.apisService.getBookById(id).subscribe({
    next: (book) => {
      const data = book.data;

      this.formData.bookName = data.bookName;
      this.formData.bookDescription = data.bookDescription;
      this.formData.autherName = data.autherName;
      this.formData.fileTypeId = data.fileTypeId;
      this.formData.categoryId = data.categoryId;
      this.formData.subCategoryId = data.subCategoryId;
      this.formData.subCategory = data.subCategory; // 🔹 store subcategory name
      this.formData.imgFile = data.imgFile;
      this.formData.bookFile = data.bookFile;
      this.imagePreview = data.imgURL;

      // Fetch subcategories for the selected category
      if (data.categoryId) {
        this.apisService.getMainSubCategories(data.categoryId).subscribe({
          next: (subRes: any) => {
            this.subCategories = subRes.data || [];

            // Pre-select the subcategory if it exists in the list
            const matched = this.subCategories.find(
              (s: any) => s.id === data.subCategoryId
            );
            if (matched) {
              this.formData.subCategoryId = matched.id;
            }
          },
          error: () => {
            this.subCategories = [];
          }
        });
      }
    },
    error: (err) => {
      console.error('Error fetching book:', err);
    }
  });
}


onCategoryChange(categoryId: number) {
  if (categoryId) {
    this.apisService.getMainSubCategories(categoryId).subscribe({
      next: (res: any) => {
        // Set subCategories to the actual array returned
        this.subCategories = res.data || []; // 🔹 do NOT wrap in [] 

        // Optional: reset selected subCategory
        this.formData.subCategoryId = null;
      },
      error: (err) => {
        console.error('Error loading subcategories:', err);
        this.subCategories = [];
        this.formData.subCategoryId = null;
      }
    });
  } else {
    this.subCategories = [];
    this.formData.subCategoryId = null;
  }
}

 getMainCategories(){
      this.loading.show()
  this.apisService.getMainCategoriess().subscribe((res: any) => {
    this.loading.hide()
    this.categories = res.data;
    this.totalItems = this.categories.length;
  })
 }

onMainCategoryChange() {

  if (this.formData.categoryId) {
    this.apisService.getMainSubCategories(this.formData.categoryId).subscribe((res: any) => {
      this.subCategories = res.data;
    });
    // Reset subcategory when category changes
    this.formData.subCategoryId = null;
  }
}

    cancel(): void {
      this.router.navigate(['/most-view-books']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

  onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.imgFile = file;
    } else if (type === 'book') {
      this.formData.bookFile = file;
    }
  }
}



 submitForm(): void {
  const formDataToSend = new FormData();

  formDataToSend.append('fileTypeId', String(this.formData.fileTypeId));
  formDataToSend.append('bookName', this.formData.bookName);
  formDataToSend.append('bookDescription', this.formData.bookDescription);
  formDataToSend.append('categoryId', String(this.formData.categoryId));
  formDataToSend.append('subCategoryId', String(this.formData.subCategoryId));
  formDataToSend.append('autherName', this.formData.autherName);
  // formDataToSend.append('imgURL', this.formData.imgFile); 
  // formDataToSend.append('bookURL', this.formData.bookFile); 

   if (this.formData.imgFile) {
    formDataToSend.append('imgURL', this.formData.imgFile);
  }

  if (this.formData.bookFile) {
    formDataToSend.append('bookURL', this.formData.bookFile);
  }

  // const id = 1; 
    const id = this.route.snapshot.paramMap.get('id'); // dynamic book id

  this.loading.show(); // ✅ Start loading


  this.apisService.editBook(+id, formDataToSend).subscribe({
    next: (res) => {
            this.loading.hide(); // ✅ Stop loading BEFORE alert

this.translate.get(['MENU.DASHBOARD.SUCCESS', 'MENU.DASHBOARD.BOOK_ADDED',  'MENU.DASHBOARD.OK'
]).subscribe(translations => {
   Swal.fire({
    title: translations['MENU.DASHBOARD.SUCCESS'],
    text: translations['MENU.DASHBOARD.BOOK_ADDED'],
    icon: 'success',
    confirmButtonText: translations['MENU.DASHBOARD.OK']
  }).then(() => {
          this.router.navigate(['/most-view-books']); // ✅ Navigate AFTER user clicks OK
        });
});
      // this.router.navigate(['/book']);
    },
    
  error: (err) => {
    console.error('Upload error:', err);

    const serverMessage = err?.error?.message || err?.message;

    this.translate.get([
      'MENU.DASHBOARD.ERROR',
      'MENU.DASHBOARD.UNEXPECTED_ERROR',
      'MENU.DASHBOARD.OK'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['MENU.DASHBOARD.ERROR'],
        text: serverMessage || translations['MENU.DASHBOARD.UNEXPECTED_ERROR'],
        icon: 'error',
        confirmButtonText: translations['MENU.DASHBOARD.OK']
      });
    });
  }
});}

}

